import React from 'react';

interface EmojiProps {
  CssClass?: string;
  Score: 0 | 1 | 2 | 3 | 4;
  Size?: number;
}

const Emoji = ({ CssClass, Score, Size }: EmojiProps) => {
  const sizePx = `${Size}px`;

  const getIcon = (score: number) => {
    switch (score) {
      case 1:
        return 'emoji-angry-fill';
      case 2:
        return 'emoji-frown-fill';
      case 3:
        return 'emoji-smile-fill';
      case 4:
        return 'emoji-laughing-fill';
      default:
        return 'question-circle-fill';
    }
  };

  return (
    <span
      className={`emoji ${
        Score < 1 ? 'emoji-question' : 'emoji-smiley'
      } bi bi-${getIcon(Score)} d-inline-block ${CssClass}`}
      style={{
        fontSize: sizePx,
        height: sizePx,
        lineHeight: sizePx,
        width: sizePx,
      }}
    />
  );
};

Emoji.defaultProps = {
  CssClass: '',
  Size: 24,
};

export default Emoji;
export { Emoji };
export type { EmojiProps };
